<template>
  <vv-progress-bar
    :progression="questionProgression.currentQuestion"
    :total="questionProgression.numberOfQuestions"
  />
</template>

<script>
import { VvProgressBar } from '@/components/common'
import { mapGetters } from 'vuex'

export default {
  name: 'QuizProgressBar',
  components: { VvProgressBar },
  computed: {
    ...mapGetters({ questionProgression: 'questionProgression' })
  }
}
</script>
